import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {Contractor} from "../../models/contractor/Contractor";
import {Nullable} from "../../models/common/Nullable";
import {
    ContractorActionTypes,
    CREATE_CONTRACTOR, CREATE_CONTRACTOR_ERROR, CREATE_CONTRACTOR_SUCCESS,
    UPDATE_CONTRACTOR, UPDATE_CONTRACTOR_ERROR,UPDATE_CONTRACTOR_SUCCESS,
    DELETE_CONTRACTOR, DELETE_CONTRACTOR_ERROR, DELETE_CONTRACTOR_SUCCESS,
    FETCH_CONTRACTOR_BY_ID, FETCH_CONTRACTOR_BY_ID_ERROR,FETCH_CONTRACTOR_BY_ID_SUCCESS,
    FETCH_CONTRACTORS, FETCH_CONTRACTORS_ERROR,FETCH_CONTRACTORS_SUCCESS,
    RESTORE_CONTRACTOR, RESTORE_CONTRACTOR_ERROR, RESTORE_CONTRACTOR_SUCCESS
} from "../../actions/contractors/ContractorActions";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";

export interface ContractorState extends BasicReducerState< Nullable< Contractor[] >, Nullable< Contractor > > {

}

export function ContractorReducer(
    state: ContractorState = initialReducerState(),
    action: ContractorActionTypes
) {

    switch ( action.type ) {
        case FETCH_CONTRACTORS:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: startFetchingRequestState()
                },
            };
        case FETCH_CONTRACTORS_SUCCESS:
            return {
                ...state,
                totalEntries: action.payload.totalEntries,
                entries: {
                    current: action.payload.entries,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_CONTRACTORS_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_CONTRACTOR_BY_ID:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.contractorId.rawValue ]: {
                        entry: null,
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_CONTRACTOR_BY_ID_SUCCESS:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.contractor.contractorId.rawValue ]: {
                        entry: action.contractor,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CONTRACTOR_BY_ID_ERROR:
            return {
                ...state,
                detailedEntries: {
                    ...state.detailedEntries,
                    [ action.contractorId.rawValue ]: {
                        ...state.detailedEntries[ action.contractorId.rawValue ],
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case CREATE_CONTRACTOR:
        case UPDATE_CONTRACTOR:
        case DELETE_CONTRACTOR:
        case RESTORE_CONTRACTOR:
            return {
                ...state,
                changingRequest: startFetchingRequestState()
            };
        case CREATE_CONTRACTOR_SUCCESS:
        case UPDATE_CONTRACTOR_SUCCESS:
        case DELETE_CONTRACTOR_SUCCESS:
        case RESTORE_CONTRACTOR_SUCCESS:
            return {
                ...state,
                changingRequest: successFetchingRequestState()
            };
        case CREATE_CONTRACTOR_ERROR:
        case UPDATE_CONTRACTOR_ERROR:
        case DELETE_CONTRACTOR_ERROR:
        case RESTORE_CONTRACTOR_ERROR:
            return {
                ...state,
                changingRequest: errorFetchingRequestState( action.error )
            };

        default:
            return state;
    }

}